<!--
 * @Descripttion: 物流首页卡片
 * @version: 1
 * @Author: lk
 * @Date: 2020-03-11 11:28:43
 -->
<template>
  <div class="list">
    <div class="imgs"><img :src="imgSrc" /></div>
    <div class="title">
      <template v-if="dataNum == 1 && !pathData">
        <!-- 动态class 路径数据是否存在 -->
        {{ dataLeft }}
      </template>
      <template v-else-if="dataNum == 1 && pathData">
        <!-- 动态class 路径数据是否存在 -->
        <a :class="{ link: pathData ? true : false }" @click="goPage(querykey, leftValue)"> {{ dataLeft }}</a>
      </template>
      <template v-else>
        <a v-if="pathData" class="link" @click="goPage(querykey, leftValue)">
          {{ dataLeft }}/
          <span class="small" @click="goPage(querykey, rightValue)">
            {{ dataRight }}
          </span>
        </a>
        <template v-else>
          {{ dataLeft }}/
          <span class="small">{{ dataRight }}</span>
        </template>

      </template>
    </div>
    <div class="text">{{ title }}</div>
  </div>
</template>
<script>
export default {
  name: 'HOMECARD',
  props: {
    statisticsInfo: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    orderData: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {}
  },
  computed: {
    /**
* 当前卡片图标，
*
*/
    imgSrc() {
      if (this.statisticsInfo.remark) {
        const { img = 'images/frame1.svg' } = eval(`(${this.statisticsInfo.remark})`)
        console.log(eval(`(${this.statisticsInfo.remark})`));
        return img
      }
      return null
    },
    /**
 * 当前卡片标题，
 *
 */
    title() {
      const { dictLabel } = this.statisticsInfo
      return dictLabel
    },
    /**
* 当前卡片展示数据数量，
* 如 dataNum: 1,
*/
    dataNum() {
      if (this.statisticsInfo.remark) {
        const { dataNum = 1 } = eval(`(${this.statisticsInfo.remark})`)
        return dataNum
      }
      return null
    },
    // 跳转参数key
    querykey() {
      if (this.statisticsInfo.remark) {
        const { querykey = null } = eval(`(${this.statisticsInfo.remark})`)
        return querykey
      }
      return null

    },
    // 跳转参数key值
    leftValue() {
      if (this.statisticsInfo.remark) {
        const { leftValue = null } = eval(`(${this.statisticsInfo.remark})`)
        return leftValue
      }
      return null

    },
    // 跳转参数key值
    rightValue() {
      if (this.statisticsInfo.remark) {
        const { rightValue = null } = eval(`(${this.statisticsInfo.remark})`)
        return rightValue
      }
      return null

    },
    /**
* 当前卡片展示数据第一个，
* 如 crrMenuUrl: '/wareHouseManagementHome/warehouseList',
*/
    dataLeft() {
      if (this.statisticsInfo.remark) {
        const { dataLeft } = eval(`(${this.statisticsInfo.remark})`)
        return this.orderData[dataLeft]
      }
      return null

    },
    /**
* 当前卡片展示数据第一个，
* 如 dataLeft: '17',
*/
    dataRight() {
      if (this.statisticsInfo.remark) {
        const { dataRight } = eval(`(${this.statisticsInfo.remark})`)
        return this.orderData[dataRight]
      }
      return null

    },
    /**
* 当前卡片展示数据跳转地址，
* 如 crrMenuUrl: '/wareHouseManagementHome/warehouseList',
*/
    pathData() {
      if (this.statisticsInfo.remark) {
        const { pathData = null } = eval(`(${this.statisticsInfo.remark})`)
        return pathData
      }
      return null

    },
  },
  methods: {
    // 左右数据点击点击跳转
    goPage(key, value) {
      // 如果没有path证明不需要跳转
      if (!this.pathData) return
      // 设置跳转参数，取pathData中参数与value值
      const query = {}
      if (key) {
        query[key] = value
      }
      this.$router.push({
        path: this.pathData.path,
        query
      })
    }
  }
}
</script>
